module.exports = __webpack_public_path__ + "img/32.4f70d764.jpg";